import { render, staticRenderFns } from "./miningRank.vue?vue&type=template&id=06934794&"
import script from "./miningRank.vue?vue&type=script&lang=js&"
export * from "./miningRank.vue?vue&type=script&lang=js&"
import style0 from "./miningRank.vue?vue&type=style&index=0&id=06934794&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports